/* Estimare livrare WARGEAR — varianta luminoasa, 3 stari (5 aug 2026)
   A) zi lucratoare inainte de cutoff: punct VERDE, "Expediem azi",
      countdown pana la cutoff-ul de azi
   B) pleaca MAINE (dupa cutoff, iar maine e zi lucratoare): punct PORTOCALIU,
      "Expediem maine", countdown-ul CURGE spre cutoff-ul de maine
   C) pleaca mai tarziu (weekend/sarbatori): punct PORTOCALIU, "Expediem luni"
      (sau ziua reala), FARA countdown, linia "comanda linistit in weekend"
   Cutoff din Theme settings; fus Europe/Bucharest (NU ora device-ului);
   zile lucratoare cu sarbatorile legale RO (fixe + mobile din Pastele ortodox). */
(function () {
  function init() {
    var root = document.querySelector('[data-wg-eta]');
    if (!root || !window.Intl || !Intl.DateTimeFormat) return;
    var elEyebrow = root.querySelector('[data-wg-eyebrow]');
    var elCronoWrap = root.querySelector('.wg-eta__crono');
    var elCrono = root.querySelector('[data-wg-crono]');
    var elTitle = root.querySelector('[data-wg-title]');
    var elLinie = root.querySelector('[data-wg-linie]');
    var cut = (root.getAttribute('data-cutoff') || '15:00').split(':');
    var cutMin = (parseInt(cut[0], 10) || 15) * 60 + (parseInt(cut[1], 10) || 0);
    var cutText = (cut[0] || '15') + ':' + (cut[1] || '00');

    /* Pastele ortodox — din el deriva Vinerea Mare (-2), lunea Pastelui (+1),
       Rusaliile (+49/+50). De completat prin 2029. */
    var EASTER = { 2026: '2026-04-12', 2027: '2027-05-02', 2028: '2028-04-16', 2029: '2029-04-08', 2030: '2030-04-28' };
    var cacheHol = {};
    function holidays(y) {
      if (cacheHol[y]) return cacheHol[y];
      var s = ['-01-01', '-01-02', '-01-06', '-01-07', '-01-24', '-05-01', '-06-01', '-08-15', '-11-30', '-12-01', '-12-25', '-12-26']
        .map(function (x) { return y + x; });
      var e = EASTER[y];
      if (e) {
        [-2, 0, 1, 49, 50].forEach(function (o) {
          s.push(new Date(new Date(e + 'T12:00:00Z').getTime() + o * 864e5).toISOString().slice(0, 10));
        });
      }
      return (cacheHol[y] = s);
    }

    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Bucharest', hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    function buc() {
      var p = {};
      fmt.formatToParts(new Date()).forEach(function (x) { if (x.type !== 'literal') p[x.type] = x.value; });
      return p;
    }
    function addDays(ds, n) { return new Date(new Date(ds + 'T12:00:00Z').getTime() + n * 864e5).toISOString().slice(0, 10); }
    function dow(ds) { return new Date(ds + 'T12:00:00Z').getUTCDay(); }
    function isWork(ds) { var d = dow(ds); return d >= 1 && d <= 5 && holidays(+ds.slice(0, 4)).indexOf(ds) < 0; }
    function nextWork(ds) { do { ds = addDays(ds, 1); } while (!isWork(ds)); return ds; }
    var ZILE = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
    function ziua(ds) { return ZILE[dow(ds)]; }
    function ddmm(ds) { return ds.slice(8, 10) + '.' + ds.slice(5, 7); }
    function pad(n) { n = Math.floor(n); return (n < 10 ? '0' : '') + n; }
    function hhmmss(sec) { return pad(sec / 3600) + ':' + pad((sec % 3600) / 60) + ':' + pad(sec % 60); }

    function tick() {
      var p = buc();
      var azi = p.year + '-' + p.month + '-' + p.day;
      var nowSec = (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second);
      var plecAzi = isWork(azi) && nowSec < cutMin * 60;
      var pleaca = plecAzi ? azi : nextWork(azi);
      var livrare = nextWork(pleaca);
      var maine = addDays(azi, 1);
      var plecMaine = !plecAzi && pleaca === maine;

      elTitle.textContent = (livrare === maine ? 'Mâine' : ziua(livrare)) + ' ' + ddmm(livrare);

      if (plecAzi) {
        root.classList.remove('wg-eta--warm');
        elEyebrow.textContent = 'Expediem azi';
        elLinie.textContent = 'La easybox sau adresă · comandă până la ' + cutText;
        elCrono.textContent = hhmmss(cutMin * 60 - nowSec);
        elCronoWrap.hidden = false;
      } else if (plecMaine) {
        root.classList.add('wg-eta--warm');
        elEyebrow.textContent = 'Expediem mâine';
        elLinie.textContent = 'La easybox sau adresă · comandă până la ' + cutText;
        elCrono.textContent = hhmmss((86400 - nowSec) + cutMin * 60);
        elCronoWrap.hidden = false;
      } else {
        root.classList.add('wg-eta--warm');
        elEyebrow.textContent = 'Expediem ' + ziua(pleaca);
        var d = dow(azi);
        var contextWeekend = d === 0 || d === 6 || (d === 5 && !plecAzi);
        elLinie.textContent = contextWeekend
          ? 'La easybox sau adresă · comandă liniștit în weekend'
          : 'La easybox sau adresă · comandă liniștit, e zi liberă';
        elCronoWrap.hidden = true;
      }
    }
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
